export const DECISION_ITEMS = `
query decisionItems(
    $searchText: String
    $filter:  FilterDecisionItemInput
    $orderBy:  DecisionItemOrderInput
    $skip: Int
    $take: Int
  ){
  decisionItems(
    searchText: $searchText
    filter: $filter
    orderBy: $orderBy
    skip: $skip
    take: $take
  ){
    __typename
    ...on DecisionItem{
      id
      tenant_id
      tax_type_id
      tax_number
      description
      description_type
      distance
      product_id
      cost_center_id
      product{
        id
        description
        code
        tenant_id
      }
      decision_item_extra_information {
        id
        decision_item_id
        extra_information
      }
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;
export const DECISION_ITEM_COUNT = `
query decisionItemCount(
  $filter: FilterDecisionItemInput, 
  $orderBy: DecisionItemOrderInput,
  $searchText: String,
) {
  decisionItemCount(
    filter: $filter,
    orderBy: $orderBy,
    searchText: $searchText
  ) {
    __typename
    ... on Count {
      count
    }
    ... on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const GET_DECISION_ITEM_CONFIGURATIONS = `
query getDecisionItemConfigurations(
$filter:FilterDecisionItemConfigurationInput!,
){
	getDecisionItemConfigurations(
		filter: $filter,
	) {
    __typename
		... on DecisionItemConfiguration {
			id
			field_name
			translation_key
			visible
			required
		}
		... on ResultError {
			status_code
			message
			message_translation_key
		}
	}
}
`;
